<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Report/TransferBarcodeSubAgent'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label-required">ตัวแทนจำหน่ายย่อย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbOriginSubAgentCode'"
                    :name="'reTbOriginSubAgentCode'"
                    :select2-options="reTbOriginSubAgentCodeOptions"
                    @selectChange="onOriginSubAgentCodeChange"
                    v-model="reTbOriginSubAgentCode"
                    ref="reTbOriginSubAgentCode"
                  ></select2>
                  <span class="form-text"></span>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">ร้านค้า:</label>
                  <treeselect
                    v-model="reTbDestinationShopCode"
                    :async="true"
                    :multiple="true"
                    :load-options="LoadreTbDestinationShopCodeOptions"
                    v-on:open="reLoadTbDestinationShopCodeOptions"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                    ref="reTbDestinationShopCode"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>อำเภอ:</label>
                  <treeselect
                    v-model="reTbAmpherId"
                    :multiple="true"
                    :options="reTbAmpherIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>BARCODE:</label>
                  <input
                    v-model="reTbBarcode"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>รหัสทรัพย์สิน(เบียร์สด):</label>
                  <treeselect
                    v-model="reTbDepartmentMaterialCode"
                    :multiple="true"
                    :load-options="LoadreTbDepartmentMaterialCodeOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <treeselect
                    v-model="reTbProductTypeId"
                    :multiple="true"
                    :options="reTbProductTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label>
                  <treeselect
                    v-model="reTbBrandId"
                    :multiple="true"
                    :options="reTbBrandIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สินค้า:</label>
                  <treeselect
                    v-model="reTbAssetCode"
                    :multiple="true"
                    :options="reTbAssetCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>จำนวนวันคงค้าง:</label>
                  <input
                    v-model="reTbOccupiedDays"
                    type="number"
                    class="form-control"
                    placeholder="กรุณาระบุจำนวนวันคงค้าง"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbReturnStatus'"
                    :name="'reTbReturnStatus'"
                    :select2-options="reTbReturnStatusOptions"
                    v-model="reTbReturnStatus"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button
                  v-if="this.$root.canShow(['SUB_AGENT_REPORT'])"
                  class="btn btn-outline-primary"
                  @click="exportTransferBarcode"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>

                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
          <hr />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reTbIsInitial: true,
      reTbOriginSubAgentCode: null,
      reTbDestinationShopCode: [],
      reTbAmpherId: [],
      reTbBarcode: null,
      reTbDepartmentMaterialCode: [],
      reTbProductTypeId: [],
      reTbAssetCode: [],
      reTbBrandId: [],
      reTbOccupiedDays: null,
      reTbReturnStatus: null,
      reTbAmpherIdOptions: [],
      reTbOriginSubAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่ายย่อย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2SubShopAgent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              onlySubAgent: true,
              onlySubAgentReport: true,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        templateResult: function(data) {
          return data.text;
        },
        language: {
          noResults: function() {
            return "ไม่พบข้อมูลร้านค้า";
          },
        },
      },
      reTbBarcodeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกBarcode",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2BarcodeAll",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reTbDepartmentMaterialCodeOptions: [],
      reTbProductTypeIdOptions: [],
      reTbBrandIdOptions: [],
      reTbAssetCodeOptions: [],
      reTbReturnStatusOptions: {
        placeholder: "กรุณาเลือกสถานะ",
        allowClear: true,
        data: [
          {
            id: "ยังไม่ได้ส่งคืน",
            text: "ยังไม่ได้ส่งคืน",
          },
          {
            id: "ส่งคืนแล้ว",
            text: "ส่งคืนแล้ว",
          },
        ],
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;

      self.reTbOriginSubAgentCode = null;
      self.reTbDestinationShopCode = [];
      self.reTbBarcode = null;
      self.reTbDepartmentMaterialCode = [];
      self.reTbProductTypeId = [];
      self.reTbAssetCode = [];
      self.reTbBrandId = [];
      self.reTbOccupiedDays = null;
      self.reTbReturnStatus = null;
      self.reTbAmpherId = [];

      $("#reTbAmpherId")
        .empty()
        .trigger("change");

      $("#reTbOriginSubAgentCode")
        .empty()
        .trigger("change");

      $("#reTbDestinationShopCode")
        .empty()
        .trigger("change");

      $("#reTbBarcode")
        .val("")
        .trigger("change");

      $("#reTbDepartmentMaterialCode")
        .val("")
        .trigger("change");

      $("#reTbProductTypeId")
        .val("")
        .trigger("change");

      $("#reTbAssetCode")
        .val("")
        .trigger("change");

      $("#reTbBrandId")
        .val("")
        .trigger("change");

      $("#reTbReturnStatus")
        .val("")
        .trigger("change");

      self.initSelectedSubAgent();
    },
    formSubmit: function(e) {
      let self = this;
      e.preventDefault();
    },
    onOriginSubAgentCodeChange: function(id, text, data, ref) {
      var self = this;
      self.reTbDestinationShopCode = [];
      self.reTbAmpherId = [];
      self.LoadreTbAmpherIdOptions();
    },
    initSelectedSubAgent: function(e) {
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดำเนินการ กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/Select2SubShopAgent",
        data: {
          search: null,
          page: 1,
          onlySubAgent: true,
          onlySubAgentReport: true,
        },
      })
        .then(function(response) {
          if (response.data != []) {
            self.$refs.reTbOriginSubAgentCode.setSelectedData({
              id: response.data.results[0].id,
              text: response.data.results[0].text,
            });
          } else {
            //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    exportTransferBarcode: function(e) {
      e.preventDefault();
      let self = this;
      if ( self.reTbOriginSubAgentCode === null || self.reTbOriginSubAgentCode.length == 0)
      {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกหรือระบุตัวแทนจำหน่ายย่อย", "warning");
        return false;
      }

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      let criterias = 0;
      if (self.reTbDestinationShopCode.length != 0) criterias++;
      if (self.reTbAmpherId.length != 0) criterias++;

      if (criterias > 1) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกหรือระบุร้านค้าหรือเลือกอำเภออย่างใดอย่างหนึ่ง",
          "warning"
        );
        return false;
      }

      if (self.reTbDestinationShopCode.length > 255) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกร้านค้าไม่เกิน 255 ร้านค้า",
          "warning"
        );
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportTransferBarcodeSubAgent",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reTbIsInitial,
          OriginSubAgentCode: self.reTbOriginSubAgentCode,
          DestinationShopCode: self.reTbDestinationShopCode,
          AmpherId: self.reTbAmpherId,
          Barcode: self.reTbBarcode,
          DepartmentMaterialCode: self.reTbDepartmentMaterialCode,
          ProductTypeId: self.reTbProductTypeId,
          AssetCode: self.reTbAssetCode,
          BrandId: self.reTbBrandId,
          OccupiedDays: self.reTbOccupiedDays,
          ReturnStatus: self.reTbReturnStatus,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    LoadreTbAmpherIdOptions: function(e) {
      var self = this;
      axios
        .post("/Api/MasterLocation/Select2SearchAmpher", {
          ShopCode: self.reTbOriginSubAgentCode || 0,
          page: 1,
        })
        .then(function(response) {
          if (response.status == 200) {
            self.reTbAmpherIdOptions = [];
            var data = response.data.results;
            data.forEach((element) => {
              self.reTbAmpherIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreTbDestinationShopCodeOptions( inputdata = null ) {
      var self = this;
      if (inputdata) {
        if (inputdata.action === ASYNC_SEARCH) {
          axios
          .post("/Api/Barcode/Select2SupShop", {
            page: 1,
            all: true,
            search: inputdata.searchQuery,
            ShopId: self.reTbOriginSubAgentCode ? self.reTbOriginSubAgentCode.split(',').map(code => code.trim()) : [],
            agentCodes: [],
            OnlySubAgentReport: true,
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              const options = [];
              data.forEach((element) => {
                options.push({
                  id: element.id,
                  label: element.text,
                });
              });
              inputdata.callback(null, options);
            }
          });
        }
      }
    },
    reLoadTbDestinationShopCodeOptions( inputdata = null ) {
      this.$refs.reTbDestinationShopCode.trigger.searchQuery = null;
    },
    LoadreTbDepartmentMaterialCodeOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reTbDepartmentMaterialCodeOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2DepartmentMaterial", {
            params: {
              agentCode: self.reTbOriginSubAgentCode,
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reTbDepartmentMaterialCodeOptions = [];
              data.forEach((element) => {
                self.reTbDepartmentMaterialCodeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reTbDepartmentMaterialCodeOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadreTbProductTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reTbProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreTbBrandIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reTbBrandIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreTbAssetCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reTbAssetCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this;
    self.initSelectedSubAgent();
    self.LoadreTbAmpherIdOptions();
    self.LoadreTbProductTypeIdOptions();
    self.LoadreTbBrandIdOptions();
    self.LoadreTbAssetCodeOptions();
    // self.LoadreTbDestinationShopCodeOptions();

    $(self.$refs.form).validate({
      ignore: ":hidden, .ignore",
      rules: {
        reTbOriginSubAgentCode: "required",
      },
      messages: {
        reTbOriginSubAgentCode: "กรุณาเลือกตัวแทนจำหน่ายย่อย",
      },
    });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/TransferBarcodeSubAgent.vue